import React from 'react';
import { Stack, ComboBox, IComboBoxOption } from '@fluentui/react';
import { ChecklistData } from '../types';
import LabeledTextField from '../common/LabeledTextField';
import IvicosStrings from 'kits/language/stringKit';

const yesNo: IComboBoxOption[] = [
    { key: IvicosStrings.yesAction, text: IvicosStrings.yesAction },
    { key: IvicosStrings.noAction, text: IvicosStrings.noAction }
];

const callIssueOptions: IComboBoxOption[] = [
    { key: IvicosStrings.webRTCDiagnosticsCallIssues.allWorking, text: IvicosStrings.yesAction },
    { key: IvicosStrings.webRTCDiagnosticsCallIssues.noneWorking, text: IvicosStrings.webRTCDiagnosticsCallIssuesNoneWorking },
    { key: IvicosStrings.webRTCDiagnosticsCallIssues.audioOnly, text: IvicosStrings.webRTCDiagnosticsCallIssuesAudioOnly },
    { key: IvicosStrings.webRTCDiagnosticsCallIssues.videoOnly, text: IvicosStrings.webRTCDiagnosticsCallIssuesVideoOnly },
    { key: IvicosStrings.webRTCDiagnosticsCallIssues.choppy, text: IvicosStrings.webRTCDiagnosticsCallIssuesChoppy }
];

interface Props {
    checklistData: ChecklistData;
    setChecklistData: React.Dispatch<React.SetStateAction<ChecklistData>>;
}

const CallIssuesAndNetwork: React.FC<Props> = ({ checklistData, setChecklistData }) => {
    const update = (key: keyof ChecklistData, val: string) => setChecklistData((prev) => ({ ...prev, [key]: val }));

    return (
        <Stack tokens={{ childrenGap: 15 }}>
            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsCallIssuesLabel}
                options={callIssueOptions}
                selectedKey={checklistData.callIssues}
                onChange={(_, option) => option && update('callIssues', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 350 } }}
            />

            {checklistData.callIssues === IvicosStrings.webRTCDiagnosticsCallIssues.choppy && (
                <Stack style={{ width: '50%' }}>
                    <LabeledTextField
                        label={IvicosStrings.webRTCDiagnosticsChoppyDescriptionLabel}
                        multiline
                        rows={3}
                        value={checklistData.choppyDescription}
                        onChange={(val) => update('choppyDescription', val)}
                    />
                </Stack>
            )}

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsOthersCanSeeHearLabel}
                options={yesNo}
                selectedKey={checklistData.othersCanSeeHear}
                onChange={(_, option) => option && update('othersCanSeeHear', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsVPNLabel}
                options={yesNo}
                selectedKey={checklistData.usingVPN}
                onChange={(_, option) => option && update('usingVPN', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />

            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsManagedITLabel}
                options={yesNo}
                selectedKey={checklistData.managedIT}
                onChange={(_, option) => option && update('managedIT', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />
            <ComboBox
                label={IvicosStrings.webRTCDiagnosticsRegionalITLabel}
                options={yesNo}
                selectedKey={checklistData.regionalIT}
                onChange={(_, option) => option && update('regionalIT', option.key as string)}
                useComboBoxAsMenuWidth
                styles={{ root: { width: 200 } }}
            />
        </Stack>
    );
};

export default CallIssuesAndNetwork;
